<template>
    <v-text-field v-if="field.type == 'text'" :label="$translate(field.title)" :rules="rules" :prepend-icon="icon" :value="value" @input="emitValue" :disabled="field.readonly" :error-messages="errorMessages" :hint="$translate(field.hint)" :persistent-hint="!!field.hint" :dense="dense" :suffix="field.suffix">
        <template #append v-if="star && field.required">
            <v-icon small :color="valueOk ? 'success' : 'error'">{{valueOk ? 'mdi-check' : 'mdi-star'}}</v-icon>
        </template>
    </v-text-field>
    <div v-else-if="field.type == 'password'">
        <v-text-field type="password" :label="$translate(field.title)" :rules="rules" :prepend-icon="icon" :value="value" @input="emitValue" :disabled="field.readonly" :error-messages="errorMessages" :hint="$translate(field.hint)" :persistent-hint="!!field.hint" :dense="dense">
            <template #append v-if="star && field.required">
                <v-icon small :color="valueOk ? 'success' : 'error'">{{valueOk ? 'mdi-check' : 'mdi-star'}}</v-icon>
            </template>
        </v-text-field>
        <v-text-field type="password" :label="$translate('Repeat') + ' ' + $translate(field.title).toLowerCase()" :prepend-icon="icon" v-model="verifyValue" :disabled="field.readonly" :rules="[requiredValue, passwordVerify]" :hint="$translate(field.hint)" :dense="dense">
            <template #append v-if="star && field.required">
                <v-icon small :color="field.value && passwordVerify() === true ? 'success' : 'error'">{{field.value && passwordVerify() === true ? 'mdi-check' : 'mdi-star'}}</v-icon>
            </template>
        </v-text-field>
    </div>
    <v-text-field v-else-if="field.type == 'email'" type="text" inputmode="email" :label="$translate(field.title)" :rules="rules" :prepend-icon="icon" :value="value" @input="emitValue" :disabled="field.readonly" :error-messages="errorMessages" :hint="$translate(field.hint)" :persistent-hint="!!field.hint" :dense="dense">
        <template #append v-if="star && field.required">
            <v-icon small :color="valueOk ? 'success' : 'error'">{{valueOk ? 'mdi-check' : 'mdi-star'}}</v-icon>
        </template>
    </v-text-field>
    <v-text-field v-else-if="field.type == 'personalCodeNumber'" type="text" inputmode="numeric" :label="$translate(field.title)" :rules="rules" :prepend-icon="icon" :value="value" @input="personalCodeNumberChange" :disabled="field.readonly" :error-messages="errorMessages" :hint="$translate(field.hint)" :persistent-hint="!!field.hint" :dense="dense">
        <template #append v-if="star && field.required">
            <v-icon small :color="valueOk ? 'success' : 'error'">{{valueOk ? 'mdi-check' : 'mdi-star'}}</v-icon>
        </template>
    </v-text-field>
    <v-text-field v-else-if="field.type == 'number'" :label="$translate(field.title)" :rules="rules" :prepend-icon="icon" type="number" inputmode="numeric" :value="value" @input="emitValue($event, 'number')" :disabled="field.readonly" :hint="$translate(field.hint)" :persistent-hint="!!field.hint" :dense="dense" :min="field.min" :max="field.max">
        <template #append v-if="star && field.required">
            <v-icon small :color="valueOk ? 'success' : 'error'">{{valueOk ? 'mdi-check' : 'mdi-star'}}</v-icon>
        </template>
    </v-text-field>
    <v-textarea v-else-if="field.type == 'textarea'" :label="$translate(field.title)" :rules="rules" :prepend-icon="icon" :value="value" @input="emitValue" :disabled="field.readonly" :hint="$translate(field.hint)" :persistent-hint="!!field.hint" :dense="dense" :rows="value ? 3 : 1">
        <template #append v-if="star && field.required">
            <v-icon small :color="valueOk ? 'success' : 'error'">{{valueOk ? 'mdi-check' : 'mdi-star'}}</v-icon>
        </template>
    </v-textarea>
    <date-field v-else-if="field.type == 'date'" :label="$translate(field.title)" :rules="rules" :prepend-icon="icon" :value="value" @input="emitValue" :disabled="field.readonly" :hint="$translate(field.hint)" :persistent-hint="!!field.hint" :dense="dense" :min="field.min" :max="field.max">
        <template #append v-if="star && field.required">
            <v-icon small :color="valueOk ? 'success' : 'error'">{{valueOk ? 'mdi-check' : 'mdi-star'}}</v-icon>
        </template>
    </date-field>
    <time-field v-else-if="field.type == 'time'" :label="$translate(field.title)" :rules="rules" :prepend-icon="icon" :value="value" @input="emitValue" :disabled="field.readonly" :hint="$translate(field.hint)" :persistent-hint="!!field.hint" :dense="dense">
        <template #append v-if="star && field.required">
            <v-icon small :color="valueOk ? 'success' : 'error'">{{valueOk ? 'mdi-check' : 'mdi-star'}}</v-icon>
        </template>
    </time-field>
    <v-checkbox v-else-if="field.type == 'checkbox'" :label="!(field.data && field.data.html) ? $translate(field.title) : undefined" :rules="rules" :prepend-icon="icon" :input-value="value" @change="emitValue" :disabled="field.readonly" :hint="$translate(field.hint)" :persistent-hint="!!field.hint" :dense="dense">
        <template #label v-if="field.data && field.data.html">
            <span v-safe-html="field.data.html" class="checkbox-html-label" @click.stop="handleCheckboxLinkClick"></span>
        </template>
        <template #append v-if="star && field.required">
            <v-icon small :color="valueOk ? 'success' : 'error'">{{valueOk ? 'mdi-check' : 'mdi-star'}}</v-icon>
        </template>
    </v-checkbox>
    <v-row no-gutters v-else-if="field.type == 'datetime'">
        <v-col md=6 cols=12>
            <date-field :label="$translate(field.title)" :rules="rules" :prepend-icon="icon" v-model="date" @input="datetimeChange" :disabled="field.readonly">
                <template #append v-if="star && field.required">
                    <v-icon small :color="valueOk ? 'success' : 'error'">{{valueOk ? 'mdi-check' : 'mdi-star'}}</v-icon>
                </template>
            </date-field>
        </v-col>
        <v-col md=6 cols=12>
            <time-field :label="$translate(field.title)" :rules="rules" :prepend-icon="icon" v-model="time" @input="datetimeChange" :disabled="field.readonly" >
                <template #append v-if="star && field.required">
                    <v-icon small :color="valueOk ? 'success' : 'error'">{{valueOk ? 'mdi-check' : 'mdi-star'}}</v-icon>
                </template>
            </time-field>
        </v-col>
    </v-row>

    <v-text-field v-else-if="field.type == 'price'" :label="$translate(field.title)" :rules="rules" :prepend-icon="icon" type="number" :value="value" @input="emitValue" :disabled="field.readonly" suffix="kr" :hint="$translate(field.hint)" :persistent-hint="!!field.hint" :dense="dense">
        <template #append v-if="star && field.required">
            <v-icon small :color="valueOk ? 'success' : 'error'">{{valueOk ? 'mdi-check' : 'mdi-star'}}</v-icon>
        </template>
    </v-text-field>

    <v-select v-else-if="['select', 'multicheckbox', 'multiselect'].includes(field.type)" :label="$translate(field.title)" :items="field.data" :prepend-icon="icon" :clearable="!field.required" :multiple="['multicheckbox', 'multiselect'].includes(field.type)" :value="value" @input="emitValue" :disabled="field.readonly" :rules="rules" :hint="$translate(field.hint)" :persistent-hint="!!field.hint" :dense="dense" :item-text="getItemText">
        <template #append v-if="star && field.required">
            <v-icon small :color="valueOk ? 'success' : 'error'">{{valueOk ? 'mdi-check' : 'mdi-star'}}</v-icon>
        </template>
    </v-select>

    <zoezi-autocomplete v-else-if="field.type == 'site'" :label="$translate(field.title)" :items="sortedSitesByName($store.state.settings.sites)" item-value="id" :prepend-icon="icon" :clearable="!field.required" :multiple="false" :value="value" @input="emitValue" :disabled="field.readonly" :rules="rules" :hint="$translate(field.hint)" :persistent-hint="!!field.hint" :dense="dense" item-text="name">
        <template #append v-if="star && field.required">
            <v-icon small :color="valueOk ? 'success' : 'error'">{{valueOk ? 'mdi-check' : 'mdi-star'}}</v-icon>
        </template>
    </zoezi-autocomplete>

    <PhoneField v-else-if="field.type == 'phone'" :label="$translate(field.title)" :icon="icon" :rules="rules" @input="emitValue" :error-messages="errorMessages" :starRequired="star && field.required" :value="value" />

    <language-menu v-else-if="field.type == 'language'" :label="$translate(field.title)" show-label>
    </language-menu>

    <color-setting v-else-if="field.type == 'color'" :label="$translate(field.title)" type="bottomdialog" :colorList="field.colors" :value="value" @input="emitValue" :rules="rules">
        <template #append v-if="star && field.required">
            <v-icon small :color="valueOk ? 'success' : 'error'">{{valueOk ? 'mdi-check' : 'mdi-star'}}</v-icon>
        </template>
    </color-setting>

    <v-radio-group v-else-if="field.type == 'radiogroup'" :rules="rules" :key="field.name" :value="value" @change="emitValue" :label="$translate(field.title)">
        <template #append v-if="star && field.required">
            <v-icon small :color="valueOk ? 'success' : 'error'">{{valueOk ? 'mdi-check' : 'mdi-star'}}</v-icon>
        </template>
        <v-radio v-for="item in field.data" :key="item.value" :label="item.text" :value="item.value"></v-radio>
    </v-radio-group>

    <div v-else>
        {{$translate('Unknown type')}}: {{field.type}} {{field.name}}
    </div>
</template>

<script>
import {isValidPersonalCode, isValidMail} from '../util.js';
import DateField from './DateField.vue'
import TimeField from './TimeField.vue'
import PhoneField from './PhoneField/PhoneField.vue';
import LanguageMenu from '../views/LanguageMenu.vue';
import ColorSetting from '../components/ColorSetting.vue'
import ZoeziAutocomplete from './ui/form/Autocomplete.vue';

export default {
    name: 'FormField',

    watch: {
        value: {
            immediate: true,
            handler(value) {
                if (this.field && this.field.type == 'datetime') {
                    let parts = (value || '').split(' ')
                    if (parts.length == 2) {
                        this.date = parts[0];
                        this.time = parts[1];
                    } else if (parts.length == 1) {
                        this.date = parts[0];
                        this.time = null;
                    } else {
                        this.date = null;
                        this.time = null;
                    }
                }
            }
        }
    },

    props: {
        value: {},
        field: {
            type: Object
        },
        star: {
            type: Boolean,
            default: false
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        probe: {
            type: Boolean,
            default: true
        }
    },

    components: {
        DateField,
        TimeField,
        PhoneField,
        LanguageMenu,
        ColorSetting,
        ZoeziAutocomplete,
    },

    data: () => ({
        date: '',
        time: '',
        errorMessages: [],
        checking: false,
        verifyValue: null
    }),

    computed: {
        rules() {
            if (this.field.readonly) {
                return [];
            }

            let res = [];
            if (this.field.required) {
                res.push(this.requiredValue);
            }

            if (this.field.type == 'email' || this.field.type == 'mail') {
                res.push(this.mailOk);
            }

            if (this.field.type == 'personalCodeNumber') {
                res.push(this.pCodeOk);
            }

            if (this.field.type == 'phone') {
                res.push(this.phoneOk);
            }

            if (this.field.type == 'password') {
                res.push(this.passwordOk);
            }

            if (this.field.type == 'text' && (this.field.min != undefined || this.field.max != undefined)) {
                res.push(this.lengthCheck);
            }

            return res.concat(this.field.rules || []);
        },
        valueOk() {
            return this.isValueValid(this.value);
        },
        icon() {
            if (!this.field.icon) {
                return null;
            }

            if (this.field.icon.startsWith('mdi-')) {
                return this.field.icon;
            }

            let icon = this.field.icon.split(' ');
            if (icon.length == 3) {
                icon = icon[2];
                if (icon.startsWith('glyphicon-')) {
                    const map = {
                        user: 'mdi-account',
                        home: 'mdi-home',
                        envelope: 'mdi-email',
                        phone: 'mdi-cellphone',
                        earphone: 'mdi-phone',
                        barcode: 'mdi-barcode',
                        'credit-card': 'mdi-creditcard',
                        'eye-open': 'mdi-eye',
                        'info-sign': 'mdi-information',
                        'heart': 'mdi-heart',
                        'asterisk': 'mdi-asterisk',
                        '': 'mdi-cake-variant'
                    };
                    return map[icon.substring(10)];
                } else if (icon.startsWith('fa-')) {
                    const map = {
                        'birthday-cake': 'mdi-cake-variant'
                    };
                    return map[icon.substring(3)];
                }
            }
            return null;
        }
    },
    methods: {
        requiredValue(x) {
            if (['multicheckbox', 'multiselect'].includes(this.field.type)) {
                if (!x || x.length == 0) {
                    return this.$translate('You must select at least one option');
                }
            }
            else if (['checkbox'].includes(this.field.type)) {
                if (!x) {
                    return this.$translate('You must check this box');
                }
            }
            else if (!x && x !== 0) {
                return this.$translate('Value must be entered');
            }

            return true;
        },
        mailOk(x) {
            if (x && !isValidMail(x)) {
                return this.$translate('No valid email address');
            }

            return true;
        },
        pCodeOk(x) {
            if (x && !isValidPersonalCode(x)) {
                return this.$translate('Incorrect social security number');
            }

            return true;
        },
        phoneOk(input) {
            if (!input) {
                return this.$translate('Incorrect phone number');
            }
            return true;
        },
        passwordOk(x) {
            if (x && x.length < 6) {
                return this.$translate('Too short password')
            }

            return true;
        },
        lengthCheck(x) {
            const min = this.field.min || 0;
            const max = this.field.max || Infinity;

            if (x.length < min) {
                return this.$translate('Too short. Minimum length is {0}').format(min)
            }

            if (x.length > max) {
                return this.$translate('Too long. Maximum length is {0}').format(max)
            }

            return true;
        },
        passwordVerify() {
            if (this.verifyValue != this.value) {
                return this.$translate('Passwords do not match');
            }

            return true;
        },
        datetimeChange() {
            let value = null;
            if (this.date) {
                value = this.date;
                if (this.time) {
                    value += ' ' + this.time;
                }
            }
            this.$emit('input', value);
        },
        getItemText(item) {
            if (this.field.format == 'translated') {
                return this.$translate(item.text);
            }

            return item.text;
        },
        personalCodeNumberChange(value) {
            if (isValidPersonalCode(value) && this.probe) {
                this.checking = true;
                this.$api.get('/api/user/probe', {personalCodeNumber: value}).then(res => {
                    this.checking = false;
                    if (res.exists) {
                        this.errorMessages = [this.$translate('The personal code number or username is already registered to another customer – please contact your facility for further assistance with logging in')];
                    } else {
                        this.errorMessages = [];
                        this.emitValue(value);
                    }
                })
            } else {
                this.errorMessages = [];
                this.emitValue(value);
            }
        },
        emitValue(value, modifier) {
            if (modifier == 'number') {
                const n = parseFloat(value)
                value = isNaN(n) ? value : n
            }

            if (this.isValueValid(value)) {
                this.$emit('input', value)
            }
        },
        isValueValid(value) {
            return !this.rules.find(rule => rule(value) !== true) && this.errorMessages.length == 0 && !this.checking;
        },
        sortedSitesByName(items) {
            return items.slice().sort((a, b) =>
                a.name.localeCompare(b.name, 'sv', { sensitivity: 'base' })
            );
        },
        handleCheckboxLinkClick(event) {
            if (event && event.target && event.target.tagName === 'A' && event.target.href) {
                event.preventDefault();
                window.open(event.target.href, '_blank');
            }
        }
    }
}
</script>

<style>
.checkbox-html-label p {
    margin: 0; /* Remove default margin of the <p> tag */
}
</style>
